<div class="amenity-selector" data-testid="amenity-selector" *transloco="let t">
  @if (label()) {
    <label class="block text-sm font-medium text-surface-700 mb-2">{{ label() }}</label>
  }
  @for (group of groupedAmenities(); track group.category) {
    <div class="amenity-category">
      <div class="category-header">
        <span class="category-label">{{ t('objects.wizard.amenityCategory.' + group.category) }}</span>
      </div>
      <div class="flex flex-wrap gap-2">
        @for (amenity of group.amenities; track amenity.id) {
          <p-chip
            [attr.data-testid]="'amenity-chip-' + amenity.id"
            [label]="amenity.name"
            [icon]="getChipIcon(amenity.id)"
            [dt]="getChipDt(amenity.id)"
            [pt]="getChipPt(amenity.id)"
            [class.chip-disabled]="disabled()"
            (click)="toggle(amenity.id)"
          />
        }
      </div>
    </div>
  }
</div>
